import {
  AlertErrorIcon,
  ArchiveIcon,
  DurationIcon,
} from '@cdl/heartbeat-react';

export const IconStatus = ({ statusOption }: any) => {
  switch (statusOption) {
    case 'ongoing':
      return <DurationIcon />;
    case 'paused':
      return <AlertErrorIcon />;
    case 'archived':
      return <ArchiveIcon />;
    default:
      return null;
  }
};
